const dateTime = new Intl.DateTimeFormat('en-AU', {
  dateStyle: 'medium',
  timeStyle: 'short',
  hour12: false,
});

export function formatDate(value: string): string {
  return dateTime.format(new Date(value));
}

export function stateLabel(value: string): string {
  if (value === 'INSUFFICIENT_DATA') return 'Insufficient data';
  if (value === 'ALARM') return 'Alarm';
  if (value === 'OK') return 'OK';
  return value;
}
